import axiosInstance from "../../../components/authentication/helper/axiosApi";
import { ActionTypes } from "../../constants/action-types";

export const fetchAnalyticsAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/analytics/`);
            
            // Log the response data to the console
            // console.log('Analytics Response:', response.data);

            dispatch({
                type: ActionTypes.SET_ANALYTICS,
                payload: response.data,
            });
        } catch (error) {
            // Handle errors here if needed
            console.error('Error fetching analytics:', error);
        }
    };
};